/**
 * This file registers all the sliders.
 *
 * @package backpress
 * @since 1.0.0
 * @author hype.media <web@hype-media.de>
 */
import 'slick-carousel';

export function sliderConfiguration() {
    const heroSlider = $('.hero-slide');
    const widgetSlider = $('.widget-slider');
    const testimoniaSlider = $('.testimonial-slider');
    const wordpressGallerySlider = $('.wp-gallery-slider');
    const cardSlider = $('.card-carousel');

    cardSlider.on('init', function () {
        let $active = $('.slick-slide.slick-current.slick-active');
        let activeVideo = $active.find('video');

        if (activeVideo.length === 1) {
            let $slickInstance = $(this);

            activeVideo[0].play();
            activeVideo[0].addEventListener('ended', function () {
                $slickInstance.slick('slickNext');
            }, false);
        }
    }).slick({
        infinite: true,
        speed: 800,
        arrows: true,
        centerMode: true,
        fade: false,
        focusOnSelect: true,
        centerPadding: 0,
        rows: 0,
        cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
        adaptiveHeight: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        variableWidth: true
    })

    cardSlider.on('beforeChange', function () {
        let $active = $('.slick-slide.slick-current.slick-active');
        let activeVideo = $active.find('video');

        if (activeVideo.length === 1) {
            activeVideo[0].pause();
        }
    });

    cardSlider.on('afterChange', function () {
        let $active = $('.slick-slide.slick-current.slick-active');
        let activeVideo = $active.find('video');

        if (activeVideo.length === 1) {
            let $slickInstance = $(this);

            activeVideo[0].play();
            $slickInstance.slick('slickPause');
            activeVideo[0].addEventListener('ended', function () {
                $slickInstance.slick('slickNext');
            }, false);
        }
    });

    heroSlider.slick({
        dots: true,
        infinite: true,
        autoplay: true,
        speed: 800,
        rows: 0,
        autoplaySpeed: 4500,
        arrows: false,
        fade: true,
        cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
        adaptiveHeight: false,
    });

    testimoniaSlider.slick({
        dots: true,
        infinite: true,
        autoplay: true,
        speed: 800,
        rows: 0,
        autoplaySpeed: 4500,
        arrows: false,
        fade: true,
        cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
        adaptiveHeight: false,
    });

    wordpressGallerySlider.slick({
        dots: true,
        infinite: true,
        autoplay: true,
        speed: 800,
        rows: 0,
        autoplaySpeed: 4500,
        arrows: true,
        fade: true,
        cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
        adaptiveHeight: false,
    });

    widgetSlider.on('afterChange', function () {
    }).slick({
        dots: true,
        infinite: true,
        speed: 400,
        arrows: true,
        centerMode: false,
        fade: false,
        rows: 0,
        cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    centerMode: false,
                    dots: true,
                    adaptiveHeight: true,
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 768,
                adaptiveHeight: true,
                settings: "unslick"
            }
        ]
    });
}

export function videoCarousel() {
    $('.custom-video-wrapper').each(function () {
        let videoItem = $(this).find('video');
        let progressBar = $(this).find('.progress-bar');
        let duration = 0;

        videoItem[0].onloadedmetadata = function() {
            duration = this.duration;
            progressBar[0].setAttribute('max', duration);
        };

        videoItem[0].addEventListener('timeupdate', function () {
            progressBar[0].style.width = (videoItem[0].currentTime / duration * 100) + '%';
        });
    });

    // jQuery('video').parent().click( function () {
    //     if(jQuery(this).children("video").get(0).paused){
    //         jQuery(this).children("video").get(0).play();
    //         jQuery(this).children(".playpause").fadeOut();
    //     }else{
    //         jQuery(this).children("video").get(0).pause();
    //         jQuery(this).children(".playpause").fadeIn();
    //     }
    // });
    //
    // var vids = jQuery("video");
    // jQuery.each(vids, function(){
    //     this.controls = false;
    // });
}
